import { createElement } from "react";
import React from "react";
import { comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { SkeletonItem, Skeleton, Switch, Text as Text$, Title3, tokens, Caption1, Subtitle2 } from "@fluentui/react-components";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { useCtx } from "../Context.jsx";
import { Role } from "../Shared/SharedModels.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Track, toastServerError, Task } from "../ApiClient.jsx";
import { errorToast } from "../Toasts.jsx";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { FSharpSet__Contains, ofArray as ofArray_1 } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { append as append_1, sortBy, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { CreateTrackDialog } from "./CreateTrack.jsx";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { General, Enrolled } from "./TrackCard.jsx";

function sectionTitle(title, subtitle) {
    let elems, el, el_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "px ",
    }], (elems = [(el = Subtitle2, createElement(el, {
        children: title,
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: subtitle,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ListTracks() {
    let elems_11;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const setAllTracks = patternInput_1[1];
    const allTracks = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const setEnrolledTracks = patternInput_2[1];
    const enrolledTracks = patternInput_2[0];
    const patternInput_3 = reactApi.useState([]);
    const setAccessibleTracks = patternInput_3[1];
    const accessibleTracks = patternInput_3[0];
    const patternInput_4 = reactApi.useState([]);
    const patternInput_5 = reactApi.useState(true);
    let patternInput_6;
    const initial_5 = equals(ctx.User.Role, new Role(1, []));
    patternInput_6 = reactApi.useState(initial_5);
    const showUnAccessibleTracks = patternInput_6[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Task.GetMyCompleted());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente mine gjennomførte oppgaver", undefined);
            }
            else {
                patternInput_4[1](res.fields[0]);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Track.GetMy());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                setEnrolledTracks([]);
            }
            else {
                setEnrolledTracks(res_1.fields[0]);
            }
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        const pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const tracksPromise = startAsPromise(equals(ctx.User.Role, new Role(1, [])) ? Track.GetAll() : Track.GetAllEnabled());
            const accessiblePromise = startAsPromise(Track.GetAccessible());
            return tracksPromise.then((_arg_1) => {
                const tracksRes = _arg_1;
                return accessiblePromise.then((_arg_2) => {
                    const accessibleRes = _arg_2;
                    return ((tracksRes.tag === 1) ? ((errorToast(setCtx, "getTracksError", "Kunne ikke hente læringsløp", "Noe gikk galt", undefined), Promise.resolve())) : ((setAllTracks(tracksRes.fields[0]), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (((accessibleRes.tag === 1) ? ((setAccessibleTracks([]), Promise.resolve())) : ((setAccessibleTracks(accessibleRes.fields[0]), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        patternInput_5[1](false);
                        return Promise.resolve();
                    })))));
                });
            });
        }));
        void (pr_4.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
    });
    const enrolledIds = ofArray_1(map((et) => et.Track.Id, enrolledTracks, Int32Array), {
        Compare: comparePrimitives,
    });
    const availableTracks = sortBy((_arg_3) => _arg_3.Name, allTracks.filter((t_3) => !FSharpSet__Contains(enrolledIds, t_3.Id)), {
        Compare: comparePrimitives,
    });
    const sortedEnrolled = sortBy((et_1) => et_1.Track.Name, enrolledTracks, {
        Compare: comparePrimitives,
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_11 = toList(delay(() => {
        let elems_2, elems, el, el_2, elems_1;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Læringsløp",
        })), (el_2 = Caption1, createElement(el_2, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Alle læringsløp",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
        }], (elems_1 = toList(delay(() => {
            let el_4;
            return append(singleton((el_4 = Text$, createElement(el_4, {
                children: "Vis utilgjengelige læringsløp",
            }))), delay(() => {
                let el_6;
                return append(singleton((el_6 = Switch, createElement(el_6, {
                    checked: showUnAccessibleTracks,
                    onChange: (_arg_4, value_1_3) => {
                        patternInput_6[1](value_1_3.checked);
                    },
                }))), delay(() => (equals(ctx.User.Role, new Role(1, [])) ? singleton(createElement(CreateTrackDialog, {
                    callback: (newTrack) => {
                        setAllTracks(append_1([newTrack], allTracks));
                    },
                })) : empty())));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_4, elems_6, elems_5;
            return patternInput_5[0] ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                gap: 15 + "px ",
            }], (elems_4 = map_1((_arg_5) => {
                let elems_3, el_8;
                const el_10 = Skeleton;
                return createElement(el_10, createObj(ofArray([["style", {
                    width: 100 + "%",
                }], (elems_3 = [(el_8 = SkeletonItem, createElement(el_8, {
                    size: 128,
                    shape: "rectangle",
                    animation: "wave",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
            }, toList(rangeDouble(1, 1, 6))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : append((sortedEnrolled.length > 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 12 + "px ",
            }], (elems_6 = [sectionTitle("Mine læringsløp", "Læringsløp du er påmeldt"), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 14 + "px ",
            }], (elems_5 = ofArray(map((et_2) => createElement(Enrolled, {
                isMobile: isMobile,
                userCompletedTasks: patternInput_4[0],
                et: et_2,
            }), sortedEnrolled)), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                let elems_8, elems_7;
                return (availableTracks.length > 0) ? append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 12 + "px ",
                }], (elems_8 = [sectionTitle("Tilgjengelige læringsløp", "Læringsløp du har tilgang til"), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 14 + "px ",
                }], (elems_7 = ofArray(map((t_5) => createElement(General, {
                    isMobile: isMobile,
                    track: t_5,
                }), accessibleTracks.filter((t_4) => !FSharpSet__Contains(enrolledIds, t_4.Id)))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                    let elems_10, elems_9;
                    return showUnAccessibleTracks ? singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 12 + "px ",
                    }], (elems_10 = [sectionTitle("Utilgjengelige læringsløp", "Læringsløp du ikke har tilgang til"), createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 14 + "px ",
                    }], (elems_9 = ofArray(map((t_7) => createElement(General, {
                        isMobile: isMobile,
                        track: t_7,
                    }), availableTracks.filter((t_6) => !accessibleTracks.some((ta) => (ta.Id === t_6.Id))))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty();
                })) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
}

//# sourceMappingURL=ListTracks.jsx.map
